module.exports = __webpack_public_path__ + "static/assets/ba085f994e0d36513b81dbf818f81c5e.png";